var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.PartnerReportClearanceCard.title")) + " "), _c('v-spacer'), _c('m-icon-button', {
    attrs: {
      "icon": "mdi-plus"
    },
    on: {
      "click": function click() {
        return _vm.isClearanceDialogOpen = true;
      }
    }
  })], 1), _c('v-card-text', [_vm.report.isClearancesLoading ? _c('v-skeleton-loader', {
    staticClass: "mb-2",
    attrs: {
      "type": "image",
      "height": "88"
    }
  }) : !_vm.report.clearances.length ? _c('m-no-content', {
    attrs: {
      "icon": "mdi-open-in-new",
      "text": _vm.$t('components.PartnerReportDetail.repair.PartnerReportClearanceCard.noContent')
    }
  }) : _c('div', [_c('partner-report-clearance-card', {
    key: 'clearance-' + _vm.report.clearances[0].id,
    staticClass: "mb-2",
    attrs: {
      "clearance": _vm.report.clearances[0],
      "report": _vm.report
    }
  }), _vm.report.clearances.length > 1 ? _c('m-expansion', {
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.PartnerReportClearanceCard.olderClearances", {
          amount: _vm.report.clearances.length - 1
        })) + " ")];
      },
      proxy: true
    }], null, false, 1701584049),
    model: {
      value: _vm.showClearances,
      callback: function callback($$v) {
        _vm.showClearances = $$v;
      },
      expression: "showClearances"
    }
  }, _vm._l(_vm.report.clearances.slice(1), function (clearance) {
    return _c('partner-report-clearance-card', {
      key: 'clearance-' + clearance.id,
      staticClass: "mb-2",
      attrs: {
        "clearance": clearance,
        "report": _vm.report
      }
    });
  }), 1) : _vm._e()], 1)], 1), _c('report-clearance-dialog', {
    model: {
      value: _vm.isClearanceDialogOpen,
      callback: function callback($$v) {
        _vm.isClearanceDialogOpen = $$v;
      },
      expression: "isClearanceDialogOpen"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }